<template>
  <div class="employee">
    <div class="employee__wrapper">
      <i class="icon-close" @click="$emit('closeModal')"></i>
      <div class="business__historic">
        <v-date-picker :value="null" is-inline @update:fromPage="toMonth" class="only-month-tregister"></v-date-picker>
        <div class="tregister__historic-wrap">
          <h4>Histórico</h4>
          <div class="tregister__historic-list" v-if="hasHistoryList">
            <div class="tregister__historic" v-for="item in businessHistoryList" :key="`tregister-historic-${item.id}`">
              <md-radio v-model="idBusinessHistoric" :value="item.id">{{ item.data.name }} - {{ item.formatDate
              }}</md-radio>
            </div>
          </div>
          <div class="tregister__historic-action">
            <!-- <md-button class="delete-color" @click="confirmDeleteAction">Delete</md-button> -->
            <md-button class="md-primary md-raised" @click="clearHistoric">Ver Actual</md-button>
          </div>
        </div>
      </div>
      <div class="employee__user">
        <!-- <div class="employee__user-img">
          <img :src="require('@/assets/img/boy.svg')" alt />
        </div> -->
        <md-field :class="getValidationClass($v.document)">
          <label>Número de RUC</label>
          <md-input v-model="document"></md-input>
          <span class="md-error" v-if="!$v.document.required">RUC es requerido</span>
          <span class="md-error" v-if="!$v.document.numeric">Solo se admite números</span>
        </md-field>

        <md-button class="md-dense md-raised md-primary employee__data-save business__data--consulta"
          @click="consultarRuc">
          <!-- <img :src="require('@/assets/img/attachment.svg')" alt /> -->
          <md-progress-spinner v-if="isLoading" :md-diameter="15" :md-stroke="2"
            md-mode="indeterminate"></md-progress-spinner>
          {{ isLoading ? "Buscando..." : "Consultar RUC" }}
        </md-button>

        <md-field>
          <label>Régimen Laboral</label>
          <md-select v-model="regLab">
            <md-option value="micro">Micro Empresa</md-option>
            <md-option value="little">Pequeña Empresa</md-option>
            <md-option value="middle-macro">Mediana/Grande Empresa</md-option>
          </md-select>
        </md-field>
        <md-field :class="getValidationClass($v.razonSocial)">
          <label>Razón Social</label>
          <md-input v-model="razonSocial"></md-input>
          <span class="md-error" v-if="!$v.razonSocial.required">Campo requerido</span>
          <!-- <span class="md-error" v-if="!$v.nombres.isAlpha">Nombres debe contener solo letras</span> -->
        </md-field>

        <md-field :class="getValidationClass($v.tipoContribuyente)">
          <label>Tipo Contribuyente</label>
          <md-input v-model="tipoContribuyente"></md-input>
          <span class="md-error" v-if="!$v.tipoContribuyente.required">Campo requerido</span>
        </md-field>
      </div>

      <div class="employee__data">
        <md-field>
          <label>Fecha de Inscripción</label>
          <md-input v-model="fechaInscripcion"></md-input>
        </md-field>

        <md-field>
          <label>Dirección de Domicilio Fiscal</label>
          <md-input v-model="address"></md-input>
        </md-field>

        <md-field :class="getValidationClass($v.legalRepresentative)">
          <label>Representante Legal o Apoderado</label>
          <md-input v-model="legalRepresentative"></md-input>
          <span class="md-error" v-if="!$v.legalRepresentative.required">Información requerida</span>
          <!-- <span class="md-error" v-if="!$v.contacto.isAlpha">Nombres debe contener solo letras</span> -->
        </md-field>

        <md-field>
          <label>Cargo del representante Legal o Apoderado</label>
          <md-input v-model="legalRepresentativePosition"></md-input>
        </md-field>

        <md-field :class="getValidationClass($v.contacto)">
          <label>Persona de contacto</label>
          <md-input v-model="contacto"></md-input>
          <span class="md-error" v-if="!$v.contacto.required">Información requerida</span>
          <!-- <span class="md-error" v-if="!$v.contacto.isAlpha">Nombres debe contener solo letras</span> -->
        </md-field>

        <md-field :class="getValidationClass($v.email)">
          <label>Correo</label>
          <md-input v-model="email"></md-input>
          <span class="md-error" v-if="!$v.email.required">Correo es requerido</span>
          <span class="md-error" v-if="!$v.email.email">Dirección email no válida</span>
        </md-field>

        <md-field :class="getValidationClass($v.phone)">
          <label>Teléfono</label>
          <md-input v-model="phone"></md-input>
          <span class="md-error" v-if="!$v.phone.required">Teléfono es requerido</span>
          <!-- <span class="md-error" v-if="!$v.phone.isPhone">Debe iniciar con 9 y tener 9 dígitos</span> -->
        </md-field>
        <md-button class="md-dense md-raised md-primary employee__data-save" @click="saveBusiness">{{ edit ? "Actualizar"
          : "Crear" }}</md-button>
      </div>
    </div>
  </div>
</template>

<script>
import {
  required,
  email,
  numeric,
  helpers,
} from "vuelidate/lib/validators";

const isAlpha = helpers.regex("alpha", /^[a-zA-ZÀ-ÿñÑ ]*$/);
// const isPhone = helpers.regex("numeric", /^9[0-9]{8}$/);
const isMoney = helpers.regex("numeric", /^[0-9]+(\.[0-9]{1,2})?$/);

export default {
  props: {
    item: Object,
    edit: Boolean,
  },
  data() {
    return {
      document: this.item.ruc,
      phone: this.item.phone,
      email: this.item.email,
      razonSocial: this.item.name,
      tipoContribuyente: this.item.taxpayerType,
      address: this.item.address,
      sueldo: null,
      regLab: this.item.type,
      fechaInscripcion: this.item.signedupAt,
      contacto: this.item.contactPerson,
      legalRepresentative: this.item.legalRepresentative,
      legalRepresentativePosition: this.item.legalRepresentativePosition,
      isLoading: false,
      dateSelect: new Date(),
      businessHistoryList: [],
      idBusinessHistoric: null
    };
  },
  async created() {
    if (!this.edit) {
      this.document = this.$store.state.business.newBusiness.ruc;
      this.phone = this.$store.state.business.newBusiness.phone;
      this.email = this.$store.state.business.newBusiness.email;
      this.razonSocial = this.$store.state.business.newBusiness.name;
      this.tipoContribuyente = this.$store.state.business.newBusiness.taxpayerType;
      this.address = this.$store.state.business.newBusiness.address;
      this.regLab = this.$store.state.business.newBusiness.type;
      this.fechaInscripcion = this.$store.state.business.newBusiness.remipe
        ? this.$store.state.business.newBusiness.remipe.FECHAACREDITACION
        : null;
      this.contacto = this.$store.state.business.newBusiness.contactPerson;
      this.legalRepresentative = this.$store.state.business.newBusiness.legalRepresentative;
      this.legalRepresentativePosition = this.$store.state.business.newBusiness.legalRepresentativePosition;
    }
    console.log(this.item);
    const { status, data } = await this.$store.dispatch("getBusinessHistory", {
      id: this.item.id,
      query: `date=${this.dateSelectQueryString}`
    })
    if (status === 200) {
      console.log({ data });
      if (data.length > 0) {
        this.businessHistoryList = data;
      } else {
        const { status, data } = this.$store.dispatch("createBusinessHistoric", {
          id: this.item.id,
          body: {
            date: this.dateSelectQueryString
          }
        });
        if (status === 200) {
          this.businessHistoryList.push(data);
        }
      }
    }
  },
  watch: {
    item(n) {
      console.log(n);
      this.document = n.ruc;
      this.phone = n.phone;
      this.email = n.email;
      this.razonSocial = n.name;
      this.tipoContribuyente = n.taxpayerType;
      this.address = n.address;
      this.regLab = n.type;
      this.fechaInscripcion = n.fechaInscripcion;
      this.contacto = n.contactPerson;
      this.legalRepresentative = n.legalRepresentative;
      this.legalRepresentativePosition = n.legalRepresentativePosition;
      this.$forceUpdate();
    },
    idBusinessHistoric: async function (n) {
      console.log("CMABIO DE HISOTIRCO", n);
      if (n) {
        const { status, data } = await this.$store.dispatch("getBusinessHistoricDetail", {
          id: this.item.id,
          fk: n
        })
        if (status > 400) {
          this.$toasted.show("Error al obtener la información historica")
          return;
        }
        console.log("data: ", {data});
        this.document = data.ruc;
        this.phone = data.phone;
        this.email = data.email;
        this.razonSocial = data.name;
        this.tipoContribuyente = data.taxpayerType;
        this.address = data.address;
        this.regLab = data.type;
        this.fechaInscripcion = data.signedupAt;
        this.contacto = data.contactPerson;
        this.legalRepresentative = data.legalRepresentative;
        this.legalRepresentativePosition = data.legalRepresentativePosition;
      } else {
        this.document = this.item.ruc;
        this.phone = this.item.phone;
        this.email = this.item.email;
        this.razonSocial = this.item.name;
        this.tipoContribuyente = this.item.taxpayerType;
        this.address = this.item.address;
        this.regLab = this.item.type;
        this.fechaInscripcion = this.item.fechaInscripcion;
        this.contacto = this.item.contactPerson;
        this.legalRepresentative = this.item.legalRepresentative;
        this.legalRepresentativePosition = this.item.legalRepresentativePosition;
      }
    }
  },
  computed: {
    razonSocialComp() {
      return this.item.name;
    },
    dateSelectQueryString() {
      return this.dateSelect.toISOString();
    },
    hasHistoryList() {
      return this.businessHistoryList.length > 0
    }
  },
  validations: {
    document: { required, numeric },
    phone: { required, numeric },
    email: { required, email },
    razonSocial: { required },
    lastName: { required, isAlpha },
    sueldo: { required, isMoney },
    contacto: { required },
    legalRepresentative: { required },
    tipoContribuyente: { required },
  },
  beforeDestroy() {
    this.$store.commit("SET_NEWBUSINESS", {});
    this.$store.dispatch("getBusiness");
  },
  methods: {
    getValidationClass(validation) {
      if (validation.$model === null) {
        return {
          "md-invalid": validation.$invalid && validation.$dirty,
        };
      } else {
        validation.$touch();
        return {
          "md-invalid": validation.$invalid && validation.$dirty,
        };
      }
    },
    consultarRuc() {
      this.isLoading = true;
      this.$store.dispatch("findByRuc", this.document).then((res) => {
        console.log(res);
        if (res.status == 200) {
          this.document = this.$store.state.business.newBusiness.ruc;
          this.razonSocial = this.$store.state.business.newBusiness.name;
          this.tipoContribuyente = this.$store.state.business.newBusiness.taxpayerType;
          this.address = this.$store.state.business.newBusiness.address;
          if (!!this.$store.state.business.newBusiness.remipe) {
            this.fechaInscripcion = this.$store.state.business.newBusiness.remipe.FECHAACREDITACION;
          } else {
            this.$toasted.info(
              "No se encontró información en la base de datos de REMYPE, llenar de forma manual",
              {
                theme: "bubble",
                position: "top-right",
                duration: 5000,
                className: "short-message",
              }
            );
          }
        } else {
          this.$toasted.show(
            "No se ha podido realizar la consulta, por favor intente otra vez",
            {
              theme: "bubble",
              position: "top-right",
              duration: 5000,
              className: "short-message",
            }
          );
        }
        this.isLoading = false;
      });
    },
    async saveBusiness() {
      if (!this.edit) {
        console.log("holi holi");
        this.$store
          .dispatch("postBusiness", {
            name: this.razonSocial,
            ruc: this.document,
            address: this.address,
            email: this.email,
            type: this.regLab,
            phone: this.phone,
            contactPerson: this.contacto,
            legalRepresentative: this.legalRepresentative,
            legalRepresentativePosition: this.legalRepresentativePosition,
            taxpayerType: this.tipoContribuyente,
            signedupAt: this.fechaInscripcion,
          })
          .then((res) => {
            console.log("posteo exitoso");
            this.$toasted.success("Empresa creada",{
                theme: "bubble",
                position: "top-right",
                duration: 5000,
                className: "short-message"
              })
            this.$emit("closeModal");
          });
      } else {
        if (!this.idBusinessHistoric) {
          const { status } = await this.$store.dispatch("putEnterprise", {
            name: this.razonSocial,
            ruc: this.document,
            address: this.address,
            email: this.email,
            phone: this.phone,
            contactPerson: this.contacto,
            type: this.regLab,
            taxpayerType: this.tipoContribuyente,
            legalRepresentative: this.legalRepresentative,
            legalRepresentativePosition: this.legalRepresentativePosition,
            id: this.item.id,
            signedupAt: this.fechaInscripcion,
          });
          if (status > 400) {
            this.$toasted.show("Error al intentar actualizar empresa", {
                theme: "bubble",
                position: "top-right",
                duration: 5000,
                className: "short-message"
              })
          } else {
            this.$toasted.success("Empresa actualizada",{
                theme: "bubble",
                position: "top-right",
                duration: 5000,
                className: "short-message"
              })
          }
        } else {
          const { status } = await this.$store.dispatch("updateBusinessHistoric", {
            id: this.item.id,
            fk: this.idBusinessHistoric,
            body: {
              name: this.razonSocial,
              ruc: this.document,
              address: this.address,
              email: this.email,
              phone: this.phone,
              contactPerson: this.contacto,
              type: this.regLab,
              taxpayerType: this.tipoContribuyente,
              legalRepresentative: this.legalRepresentative,
              legalRepresentativePosition: this.legalRepresentativePosition,
              id: this.item.id,
              signedupAt: this.fechaInscripcion,
            }
          })
          if (status > 400) {
            this.$toasted.show("Error al intentar actualizar la data historica de la empresa", {
                theme: "bubble",
                position: "top-right",
                duration: 5000,
                className: "short-message"
              })
          } else {
            this.$toasted.success("Data historica de la empresa actualizada")
          }
        }
      }
      this.$emit("closeModal");
    },
    async toMonth(val) {
      if (val) {
        this.dateSelect = new Date(val.year, val.month, 0);
        const { status, data } = await this.$store.dispatch("getBusinessHistory", {
          id: this.item.id,
          query: `date=${this.dateSelectQueryString}`
        });
        if (status === 200) {
          if (data.length > 0) {
            this.businessHistoryList = data;
          } else {
            const { status, data } = this.$store.dispatch("createBusinessHistoric", {
              id: this.item.id,
              body: {
                date: this.dateSelectQueryString
              }
            });
            if (status === 200) {
              this.businessHistoryList.push(data);
            }
          }
        }
      }
    },
    clearHistoric() {
      this.idBusinessHistoric = null;
    }
  },
  filters: {
    phoneNumber(value) {
      value = value.toString();
      return value.slice(0, 3) + " " + value.slice(3, 6) + " " + value.slice(6, 9);
    },
  }
};
</script>

<style lang="scss" scoped>
//1-SETTINGS
//colors
$b-orange: #d8ff00;
$b-blue: #000000;
$b-emph: #97c2c9;
$b-blue-dark: #c63832;
//breakpoints
$sm: 600px;
$md: 900px;
$lg: 1200px;
$xl: 1800px;
//variables
$p-img: "../assets/img/";

//2-VENDORS

//3-TOOLS
//functions
//background-image function
@function bimg($img) {
  @return url($p-img + $img);
}

//mixins
@mixin mq($min-width) {
  @media screen and (min-width: $min-width) {
    @content;
  }
}

//8-TRUMPS
//vue-material
.md-field {
  width: 15rem;

  // margin: 0 3rem 2rem 3rem;
  @include mq($sm) {
    width: 21rem;
  }

  &.md-theme-default {
    label {
      color: rgba($b-emph, 0.6);

      &::after {
        color: $b-orange;
      }
    }

    &::after {
      background-color: #d7dae2;
    }

    &::before {
      background-color: $b-emph;
    }

    &.md-focused {
      label {
        color: $b-blue-dark;
      }
    }

    &.md-invalid {
      label {
        color: $b-orange;
      }

      &::after {
        background-color: $b-orange;
      }

      .md-error {
        color: $b-orange;
      }
    }
  }
}

.employee {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 600;
  background-color: rgba(46, 54, 103, 0.75);

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    box-shadow: 0 0 2000px rgba($b-blue-dark, 0.75) inset;
    background: inherit;
  }

  &__wrapper {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background-color: #fff;
    overflow-y: scroll;
    padding: 3rem 0.5rem 2rem 0.5rem;

    @include mq($md) {
      width: 90%;
      max-width: 75rem;
      height: 100%;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }

    @include mq($lg) {
      overflow-y: visible;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-around;
      align-items: flex-start;
      padding: 3rem 0 1rem;
      gap: 1rem
    }

    .icon-close {
      position: absolute;
      top: 0.6rem;
      right: 0.6rem;
      font-size: 2rem;
      color: $b-orange;

      @include mq($lg) {
        font-size: 3rem;
        top: 1rem;
        right: 1rem;
        cursor: pointer;
      }
    }
  }

  .business__historic {
    flex-grow: 0;
    flex-shrink: 1;
    margin: 0;
    display: flex;
    flex-flow: column;
    justify-content: flex-start;
    align-items: center;
  }

  &__user {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 3rem 0 0;

    @include mq($lg) {
      padding-bottom: 0;
      margin-top: 0;
    }

    &-contrato {
      height: 3rem !important;
      width: 15rem !important;
      background-color: $b-blue !important;
    }
  }

  &__data {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 3rem;
    padding-bottom: 6rem;
    margin-left: 0;
    margin-right: 0;

    @include mq($lg) {
      padding-bottom: 0;
      margin-top: 0;
    }

    &-save {
      margin-top: 3rem;
      height: 3rem !important;
      width: 15rem !important;
      background-color: $b-emph !important;

      @include mq($lg) {
        margin-top: 0;
      }
    }
  }
}

.business__data--consulta {
  margin-top: 1rem;
  margin-bottom: 1rem;

  .md-ripple .md-button-content {
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-around;
    align-items: center;
  }
}
</style>
